module.exports = __webpack_public_path__ + "app/kiss-user/list-kiss-users-3cIYJ-Mi.html";